import { memo } from 'react'

import { MOOD_ICON_COLOR, MOOD_MOUTH_PATH } from './config'
import type { MoodIconProps } from './types'

/** Смайлик состояния «Как ты сейчас?»: круг r=9 в viewBox 22, глаза-точки, рот — дуга из спеки. */
export const MoodIcon = memo(function MoodIcon(props: MoodIconProps) {
  const { mood, size = 22, color = 'MUTED' } = props
  const stroke = MOOD_ICON_COLOR[color]

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 22 22'
      fill='none'
      stroke={stroke}
      strokeWidth={1.4}
      strokeLinecap='round'
      aria-hidden='true'
      focusable='false'
    >
      <circle cx={11} cy={11} r={9} />
      <path d={MOOD_MOUTH_PATH[mood]} />
      <circle cx={8.1} cy={8.9} r={0.2} fill={stroke} strokeWidth={1.6} />
      <circle cx={13.9} cy={8.9} r={0.2} fill={stroke} strokeWidth={1.6} />
    </svg>
  )
})
